import { HTMLAttributes } from 'react'

export enum ETooltipSide {
  LEFT = 'left',
  RIGHT = 'right',
  TOP = 'top',
  BOTTOM = 'bottom',
}

export interface ITooltipProps extends HTMLAttributes<HTMLDivElement> {
  side?: ETooltipSide
}
